export default {"src":"//_next/static/media/link-icon.7d72425d.svg","height":24,"width":24};